import React, { Component, useState } from "react"
import { withRouter, RouteComponentProps } from "react-router-dom"
import { CDN_PUB_URL_SPRINTS } from "../../constants"
import Button from "../../components/Button/Button"
import Calculator, { CalculatorConfig } from "../../components/Calculator"
import { capitilizeFirstLetter } from "../../services/utils/text-util"
import { getBellringerSetNumber, getBellringersTestQuestions, getBellringerTestMetaData, IBellringersTestQuestion, WEEKLY_QUESTIONS_PER_SUBJECT } from "../../services/bellringers"
import { SimpleTimer } from "../../services/utils/simple-timer"
import { Context, Resource, sendUserActivity, UserActivityEx } from "../../services/liveview/liveview-service"
import { SprintsRest } from "../../services/sprints/sprints-rest-interface"
import ComputerTestACT from "../Practice/VirtualPractice/ACT/ComputerTestACT"
import { ACT_SECTION_MODULE_KEYS } from "../../services/utils/practice-test-util"
import SprintsWorkflow from "./SprintsWorkflow"

interface Props {
    userInfo: any
    testId: string
}

interface State {
    loadError?: string
    fullSprintInfo?: any
    currentQuestionIndex: number
    showModal: boolean
    miniReviewPageVisible: boolean
    mainReviewPageVisible: boolean
    calculatorVisibleACT: boolean
    disablePrev: boolean
    disableNext: boolean
    showFinishButton: boolean
}

type AllProps = Props & RouteComponentProps<any>

export class SprintsTest extends Component<AllProps, State> {
    constructor(props) {
        super(props)
        this.state = {
            fullSprintInfo: undefined,
            currentQuestionIndex: 0,
            showModal: false,
            miniReviewPageVisible: false,
            mainReviewPageVisible: false,
            calculatorVisibleACT: false, // ACT calc
            disablePrev: true,
            disableNext: false,
            showFinishButton: false,
        }
    }

    componentDidMount(): void {
        this.initialize()
    }

    initialize = async () => {
        let {testId} = this.props
        this.setState({loadError: undefined})
        try {
            let fullSprintInfo = await SprintsRest.getFullSprintWithUserAnswers(testId)
            this.setState({fullSprintInfo})
        } catch (error) {
            this.setState({loadError: "Unable to load the sprint. Please try again."})
        }
    }

    componentWillUnmount(): void {

    }


    handleTestExit = () => {
        let routeState = this.props.location.state as {returnTab?: string, returnCardKey?: string} | undefined
        let returnTab = routeState && routeState.returnTab
        let subject = this.props.testId.match(/^act-(english|math|reading|science)-/i)
        let tab = returnTab || (subject && subject[1])
        this.props.history.push(`/app/sprints${tab ? `#${tab}` : ""}`, {
            returnCardKey: routeState && routeState.returnCardKey,
        })
    }

    render() {
        let {userInfo, testId} = this.props
        let {fullSprintInfo} = this.state

        if (this.state.loadError) return <div role="alert">{this.state.loadError} <button onClick={this.initialize}>Retry</button></div>
        if (!fullSprintInfo) return null

        return (
            <div className="sprints-test">
                <SprintsWorkflow userInfo={userInfo} fullSprintInfo={fullSprintInfo} testId={testId} onTestExit={this.handleTestExit}/>
            </div>
        )
    }

}


const ConnectedSprintsTest = withRouter(SprintsTest)

export default (props) => {
    return (
        <ConnectedSprintsTest {...props} />
    )
}
